import React from "react";
import { Link } from "react-router-dom";
const Firebanner = () => {


let backgroundImage = "/assets/img/bg/3.jpg"; // default



  return (
    <>
      <section
        className="breadcrumb__area include-bg breadcrumb__overlay Product_banner"
        // data-background="assets/img/breadcrumb/slider11.png"
        style={{
               backgroundImage: `url("${backgroundImage}")`,
          zIndex: "0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="breadcrumb__content text-center p-relative z-index-1">
                <h3 className="breadcrumb__title">Our Fire Safety Project</h3>
                <div className="breadcrumb__list">
                  <span>
                    <Link to="/">Home</Link>
                  </span>
                  <span className="dvdr">:</span>
                  <span>Fire Safety</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Firebanner;
